import React from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = ({ setLanguage }) => {
  const { t } = useTranslation();
  const setLoginModalShow = useContextSelector(
    AuthContext,
    (ctx) => ctx.setLoginModalShow,
  );
  const setShowAccount = useContextSelector(
    AuthContext,
    (ctx) => ctx.setShowAccount,
  );
  const navigate = useNavigate()
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  return (
    <div className="bottom-navigator d-md-none">
      {isEmpty(user) ? (
        <div className="row bottom-navigator-before-login no-gutters">
          <div
            onClick={() => setLanguage(true)}
            className="bottom-navigator-before-login-first d-flex flex-row justify-center align-center no-gutters col col-4"
          >
            <div className="d-flex flex-column justify-center align-center">
              <button
                type="button"
                className="v-btn v-btn--icon v-btn--round theme--light v-size--small"
              >
                <span className="v-btn__content">
                  <div
                    className="v-avatar language-button"
                    style={{
                      height: "25px",
                      "min-width": "25px",
                      width: "25px",
                    }}
                  >
                    <img
                      src="/static/image/country/BDT.svg"
                      alt={t("AltJaya9CricketExchange")}
                    />
                  </div>
                </span>
              </button>
            </div>
            <div
              no-gutters
              className="d-flex flex-column justify-center align-center"
            >
              <span style={{ "font-size": "12px" }}>{t("English")}</span>
              <span style={{ "font-size": "12px" }}>{t("Bengali")}</span>
            </div>
          </div>
          <div
            onClick={() => setLoginModalShow(true)}
            className="bottom-navigator-before-login-third d-flex justify-center align-center no-gutters col col-4"
          >
            <b>{t("Login")}</b>
          </div>
          <div onClick={() => navigate('/register')} className="bottom-navigator-before-login-second d-flex justify-center align-center no-gutters col col-4">
            <b>{t("Singup")}</b>
          </div>
        </div>
      ) : (
        <div className="row no-gutters">
          <div className="grow col col-auto">
            <Link
           to='/'
              className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default"
              style={{ height: "auto" }}
            >
              <span className="v-btn__content">
                <div className="text-center">
                  <img
                    src="/static/svg/mobileBottomNavigation/toolbar-icon-home.svg"
                    alt={t("AltJaya9CrazytimeExchange")}
                    className="icon_btm_nav"
                  />
                  <p>{t("Home")}</p>
                </div>
              </span>
            </Link>
          </div>
          <div className="grow col col-auto">
            <Link
              to="/promotion"
              className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default"
              style={{ height: "auto" }}
            >
              <span className="v-btn__content">
                <div className="text-center">
                  <img
                    src="/static/svg/mobileBottomNavigation/toolbar-icon-promotion.svg"
                    alt={t("AltJaya9CrazytimeExchange")}
                    className="icon_btm_nav"
                  />
                  <p>{t("Promotion")}</p>
                </div>
              </span>
            </Link>
          </div>
          <div className="grow col col-auto">
            <Link
              to="/deposit"
              className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default"
              style={{ height: "auto" }}
            >
              <span className="v-btn__content">
                <div className="text-center">
                  <img
                    src="/static/svg/mobileBottomNavigation/toolbar-icon-deposit.svg"
                    alt={t("AltJaya9CrazytimeExchange")}
                    className="icon_btm_nav"
                  />
                  <p>{t("Deposit")}</p>
                </div>
              </span>
            </Link>
          </div>
          <div className="grow col col-auto">
            <a
           
              onClick={() => setShowAccount(true)}
              className="v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default"
              style={{ height: "auto" }}
            >
              <span className="v-btn__content">
                <div className="text-center">
                  <img
                    src="/static/svg/mobileBottomNavigation/toolbar-icon-mine.svg"
                    alt={t("AltJaya9CrazytimeExchange")}
                    className="icon_btm_nav"
                  />
                  <p>{t("Profile")}</p>
                </div>
              </span>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
